module.exports = __webpack_public_path__ + "img/default.1a1156a2.png";